/* eslint-disable no-duplicate-imports */
import { getUrlSync, IActionContext } from '@msdyn365-commerce/core';

/**
 * Retrieves the url for reorder page.
 * @param actionContext - Core action context.
 * @param orderNumber - Number of order.
 * @returns Url for reorder Page.
 */
export const getReorderPageUrl = (actionContext: IActionContext, orderNumber: string): string => {
    const reorderDetailsUrl = getUrlSync('createOrder', actionContext) || '';
    const separator = reorderDetailsUrl.includes('?') ? '&' : '?';
    return `${reorderDetailsUrl}${separator}orderNumber=${orderNumber}`;
};
